import React from 'react'
import { BadgeProps } from './Badge.types'
import { StyledBadge } from './Badge.styles'

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  size = 'medium',
  className,
  ...props
}) => {
  return (
    <StyledBadge
      $variant={variant}
      $size={size}
      className={className}
      {...props}
    >
      {children}
    </StyledBadge>
  )
}
